module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.product).length > 0) ? _c('section', {
    staticClass: "flexContainer fd-c full",
    attrs: {
      "id": "imageEditor"
    }
  }, [(_vm.product.infosArticle.hasOwnProperty('diam_ref1')) ? _c('h1', {
    staticClass: "uppercase txtCenter listTitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$tradFor(_vm.product.terms.name)) + " [ " + _vm._s(_vm.product.id) + " ] "), _c('br'), _vm._v("\n        Ref diam : " + _vm._s(_vm.product.infosArticle.diam_ref1.componentProperty.value) + "\n    ")]) : _c('h1', {
    staticClass: "uppercase txtCenter listTitle"
  }, [_vm._v(_vm._s(_vm.$tradFor(_vm.product.terms.name)) + " [ " + _vm._s(_vm.product.id) + " ] "), _c('br')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "collection with-header"
  }, [_c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "list": _vm.getImgObject
    },
    on: {
      "end": function($event) {
        _vm.endDrag()
      }
    }
  }, _vm._l((_vm.getImgObject), function(img, key) {
    return _c('div', {
      key: key,
      staticClass: "collection-item center box borderImg",
      style: ({
        border: (_vm.actImg === img.id ? '3' : '1') + 'px solid' + (_vm.actImg === img.id ? _vm.linkColor : '#9b9b9b'),
        backgroundColor: _vm.actImg === img.id ? _vm.linkColor + '40' : 'transparent'
      }),
      on: {
        "mouseover": function($event) {
          _vm.activeImg(img.id)
        },
        "mouseleave": function($event) {
          _vm.inactiveImg()
        }
      }
    }, [_c('div', {
      staticClass: "encart",
      style: ('background:' + (_vm.actImg === img.id ? _vm.linkColor : '#9b9b9b'))
    }, [_c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(key + 1))])]), _vm._v(" "), (img.img.hasOwnProperty('medium')) ? _c('img', {
      staticClass: "imageEditor",
      attrs: {
        "src": _vm.getImgPath(img.img.medium),
        "alt": "",
        "height": "100"
      }
    }) : _c('img', {
      staticClass: "imageEditor",
      attrs: {
        "src": img.img.filename,
        "alt": "",
        "height": "100"
      }
    }), _vm._v(" "), (!!img.img.name) ? _c('div', {
      staticClass: "imageTypeInfo"
    }, [_vm._v(_vm._s(img.img.name[_vm.$t("trad")]))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "deleteImg pointer",
      attrs: {
        "id": 'deletedImg' + key
      },
      on: {
        "click": function($event) {
          _vm.removeImageFromProduct(img.id)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$t("imgEditor.delete")) + "\n                        ")])])
  }))], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t("imgEditor.infoDrag")))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "center upload"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, _vm._l((_vm.range), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "ai-fe"
    }, [_c('div', {
      staticClass: "labelInfo"
    }, [_c('label', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(_vm.$t("imgEditor.labelImg")))]), _vm._v(" "), _c('vue-base64-file-upload', {
      staticClass: "upload flexContainer ai-fe labelInfo container-upload",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "id": 'photo' + index,
        "accept": "image/png,image/jpeg,image/svg+xml",
        "image-class": "thumbnail",
        "input-class": "thumbnail",
        "max-size": _vm.customImageMaxSize,
        "enctype": "multipart/form-data"
      },
      on: {
        "size-exceeded": _vm.onSizeExceeded,
        "file": _vm.onFile,
        "load": _vm.onLoad
      }
    }), _vm._v(" "), (_vm.uploadError) ? _c('div', {
      staticClass: "uploadError"
    }, [_vm._v(_vm._s(_vm.uploadError))]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "labelInfo"
    }, [(_vm.product.type.name !== 'product') ? _c('label', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(_vm.$t("imgEditor.labelSelect")))]) : _vm._e(), _vm._v(" "), (_vm.product.type.name !== 'product') ? _c('div', {
      staticClass: "upload labelInfo"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedType[index]),
        expression: "selectedType[index]"
      }],
      attrs: {
        "name": 'typePhoto' + index,
        "id": 'typePphoto' + index
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selectedType, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.fileType(index)
        }]
      }
    }, _vm._l((_vm.userFT), function(type, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": type.id
        }
      }, [_vm._v(_vm._s(type.name[_vm.$t("trad")]))])
    })), _vm._v(" "), (_vm.erreur) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Veuillez sélectionner un type")]) : _vm._e()]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "fd-r mt10"
  }, [_c('button', {
    staticClass: "save btn pointer uppercase",
    on: {
      "click": function($event) {
        _vm.editPhoto()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("imgEditor.save")))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn uppercase",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s("back to catalogue item"))])]), _vm._v(" "), (_vm.loading === true) ? _c('div', {
    staticClass: "abs flexContainer",
    attrs: {
      "id": "spinnerLoader"
    }
  }, [_c('Spinner', {
    staticClass: "loader",
    attrs: {
      "animation-duration": 2500,
      "size": 70,
      "color": '#41b4e8'
    }
  })], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fd1c3c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/ImgEditor.vue
// module id = 3105
// module chunks = 0